import { useInReverseTrial } from '@atlassian/jira-reverse-trial-utils/src/controllers/use-in-reverse-trial/index.tsx';

type ReverseTrialInfo = {
	isReady: boolean;
	isInReverseTrial: boolean | undefined;
};

export const useReverseTrials = (): ReverseTrialInfo => {
	const { isInReverseTrial, isReady: isRTReady } = useInReverseTrial();

	if (!isRTReady) {
		return {
			isReady: false,
			isInReverseTrial: undefined,
		};
	}

	return {
		isReady: true,
		isInReverseTrial,
	};
};
